import {useState} from 'react';
import NoteForm from './NoteForm';

export default function NoteItem({note, onUpdate, onDelete}) {
    const [editing, setEditing] = useState(false);

    if (editing) {
        return (
            <li className="note-card">
                <NoteForm
                    initialNote={note}
                    submitLabel="Enregistrer"
                    onCancel={() => setEditing(false)}
                    onSubmit={async (values) => {
                        await onUpdate(note.id, values);
                        setEditing(false);
                    }}
                />
            </li>
        );
    }

    return (
        <li className="note-card">
            <h3>{note.title}</h3>
            {note.content && <p className="note-content">{note.content}</p>}

            <div className="tag-list">
                {note.tags.map(tag => <span key={tag} className="chip">{tag}</span>)}
            </div>

            <div className="row">
                <button type="button" onClick={() => setEditing(true)}>Modifier</button>
                <button type="button" className="danger" onClick={() => onDelete(note.id)}>Supprimer</button>
            </div>
        </li>
    );
}
